import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import J1939FrameDecoder from '../components/tools/j1939FrameDecoder/J1939FrameDecoder';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'J1939 Frame Decoder & DBC Generator | AUTOXIUM';
const PAGE_DESCRIPTION = 'Decode SAE J1939 CAN frames: 29-bit ID to priority, PGN and source address, SPN decode with error / not-available flags and a bit map, then generate, validate and download a J1939 DBC.';

const J1939FrameDecoderPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="j1939-frame-decoder-page">
      <PageHero
        eyebrow="Engineering Utilities / Communication"
        title="J1939 Frame Decoder & DBC Generator"
        description="Enter a 29-bit J1939 CAN ID and its data bytes to see the priority, PGN, source and destination address — then define the SPNs, decode them with J1939 error / not-available flags, and generate a validated J1939 DBC file."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="j1939-frame-decoder-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <J1939FrameDecoder />
          <ToolGuideCta guidePath="/tools/j1939-frame-decoder/guide" toolName="J1939 Frame Decoder & DBC Generator" />
        </div>
      </section>
    </div>
  );
};

export default J1939FrameDecoderPage;
